<!-- @veltra/icons generated sha256:1fc711637f6db902 gen:8 source:src/svg/normal/form-date-range-picker.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormDateRangePicker' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="14"
      height="11"
      x="1"
      y="3"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <path stroke="currentColor" stroke-linecap="round" stroke-width="1.2" d="M1 7h14M4 1v3m8-3v3" />
    <rect width="8" height="2" x="4" y="9.5" fill="currentColor" rx="1" />
  </svg>
</template>
